<template>
  <div class="approver-rule">
    <mode-cards :value="card" :options="CARDS" name="approver-mode" legend="Who can approve" @input="onCard" />

    <div v-if="card === 'manager'" class="approver-rule__level">
      <div class="approver-rule__label">Which manager?</div>
      <app-input
        :value="value"
        type="radio"
        name="Which manager"
        :options="LEVELS"
        :validate-immediate="false"
        button-variant="outline-primary"
        buttons
        class="mb-0"
        @input="$emit('input', $event)"
      />
      <p class="approver-rule__example">{{ example }}</p>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import AppInput from '@/components/AppInput.vue';
import ModeCards from '@/pages/recognition/components/ModeCards.vue';
import { APPROVER_MODES } from '@/pages/recognition/constants';

const CARDS = [
  { value: 'people', title: 'Specific people', sub: 'Named employees or whole divisions' },
  { value: 'manager', title: 'Their manager', sub: 'From the HR reporting line' },
];

const LEVELS = [
  { text: 'Direct manager', value: APPROVER_MODES.MANAGER },
  { text: 'One level up', value: APPROVER_MODES.MANAGERS_MANAGER },
];

const EXAMPLES = {
  [APPROVER_MODES.MANAGER]: "For example, Sam's nominations go to Sam's line manager.",
  [APPROVER_MODES.MANAGERS_MANAGER]: "For example, Sam's nominations go to the manager of Sam's line manager.",
};

// The three approver modes as two choices: named people, or the nominee's manager at one of two levels.
export default {
  name: 'ApproverRuleField',
  components: { AppInput, ModeCards },
  props: {
    value: { type: String, default: APPROVER_MODES.PEOPLE }, // an APPROVER_MODES value
  },
  emits: ['input'],
  setup(props, { emit }) {
    const card = computed(() => (props.value === APPROVER_MODES.PEOPLE ? 'people' : 'manager'));
    const example = computed(() => EXAMPLES[props.value]);
    const onCard = next => emit('input', next === 'people' ? APPROVER_MODES.PEOPLE : APPROVER_MODES.MANAGER);
    return { CARDS, LEVELS, card, example, onCard };
  },
};
</script>

<style scoped lang="scss">
.approver-rule {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.approver-rule__level {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.approver-rule__label {
  color: var(--palette-color-default);
  font-weight: 600;
}

.approver-rule__example {
  color: var(--palette-color-default-lighten-20);
  font-size: 0.8125rem;
  margin: 0;
}
</style>
